import React, { FC } from 'react';
import { useSupergridMutations, useSuperGridValidate } from '@aleph/supergrid';
import {
	Button, ButtonAppearance, ButtonColor, ButtonSize, TrashCanIcon,
} from '@aleph/shared-components';
import { ICellRendererParams } from 'ag-grid-community';

const VerticalNameCellRenderer: FC<ICellRendererParams> = (params) => {
	const { removeMutationTree } = useSupergridMutations();
	const { context: { setValidations } } = useSuperGridValidate();

	const removeMutationTreeAndValidations = (hash: string) => {
		removeMutationTree(hash);
		setValidations((curr) => curr.filter((validation) => validation.id !== hash));
	};

	return (
		<div className="flex items-center gap-[8px] h-full px-[8px] overflow-hidden h-full">
			<div className="flex-1 font-medium whitespace-nowrap overflow-hidden overflow-ellipsis">
				{params.value}
			</div>
			{!params.data.id && <Button
				onClick={() => removeMutationTreeAndValidations(params.data?.hash)}
				leftNode={<TrashCanIcon />}
				appearance={ButtonAppearance.OUTLINED}
				color={ButtonColor.RED}
				size={ButtonSize.SMALL}
			/>
			}
		</div>
	);
};

export default VerticalNameCellRenderer;
